import moment from "moment";

/** Ledger Template */
const ledgerPattern = ({
    date,
    companyName,
    companyAddress,
    companyContact,
    gst,
    customerName,
    customerDetails,
    customerGST,
    customerContact,
    ledger,
    balance,
    credit,
    debit,
}) => {

    let prevRunninBal = 0;
    if (customerDetails === undefined) {
        customerDetails = ''
    }
    return `
    <!DOCTYPE html >
<html >

<head>
    <meta http-equiv='Content-Type' content='text/html; charset=UTF-8' />
	<link rel='stylesheet' type='text/css' href='invoice.css' />
	
	<title>Ledger - ${customerName}</title>
</head>  
<style> 
* {
    margin: 0;
    padding: 0;
}

body {
    font: 14px/1.4 Georgia, serif;
}

#page-wrap {
    width: 800px;
    margin: 0 auto;
}

textarea {
    border: 0;
    font: 14px Georgia, Serif;
    overflow: hidden;
    resize: none;
}

table {
    border-collapse: collapse;
}

table td,
table th {
    border: 1px solid black;
    padding: 5px;
}

#hiderow,
.delete {
    display: none;
}

#header {
    
    width: 100%;
    margin: 20px 0;
    background: #222;
    text-align: center;
    color: white;
    font: bold 15px Helvetica, Sans-Serif;
    text-decoration: uppercase;
    letter-spacing: 20px;
    padding: 8px 0px;
}

#company {
    width: 250px;
    height: 100px;
}

#customer {
    overflow: hidden;
}

#logo {
    text-align: right;
    float: right;
    position: relative;
    margin-top: 25px;
    border: 1px solid #fff;
    max-width: 540px;
    max-height: 100px;
    overflow: hidden;
}

#customer-title {
    font-size: 20px;
    font-weight: bold;
    
}

#meta {
    margin-top: 1px;
    width: 300px;
    float: right;
    margin-bottom: 10px;
}

#meta td {
    text-align: right;
}

#meta td.meta-head {
    text-align: left;
    background: #eee;
}

#meta td textarea {
    width: 100%;
    height: 20px;
    text-align: right;
}

#items {
    clear: both;
    width: 100%;
    margin: 30px 0 0 0;
    border: 1px solid black;
    
}

#items th {
    background: #eee;
}

#items textarea {
    width: 80px;
    height: 50px;
}

#items tr.item-row td {
    padding-bottom: 5px;
    text-align: center;
    border: 0;
    vertical-align: top;
}

#items td.description {
    width: 300px;
}

#items td.item-name {
    width: 300px;
}

#items td.description textarea,
#items td.item-name textarea {
    width: 100%;
}

#items td.total-line {
    border-right: 0;
    text-align: right;
}

#items td.total-value {
    border-left: 0;
    padding: 10px;
}

#items td.total-value  {
    background: none;
    text-align: center;
}

#items td.balance {
    background: #eee;
}

#items td.blank {
    border: 0;
}
#items td.end {
    border-top: 1px solid black;
    border-bottom: 1px solid black;
}

#terms {
    text-align: center;
    margin: 20px 0 0 0;
}

#terms h5 {
    text-transform: uppercase;
    font: 13px Helvetica, Sans-Serif;
    letter-spacing: 10px;
    border-bottom: 1px solid black;
    padding: 0 0 8px 0;
    margin: 0 0 8px 0;
}

#terms  {
    width: 100%;
    text-align: center;
}

</style>
<body>

	<div id="page-wrap">

		<h5 id="header">LEDGER</h5>
		
		<div id="identity">
            <div id="company">
                <p> ${companyName} </p>
                <p> ${companyAddress} </p>
                <p> ${companyContact} </p>
                <p>${gst && 'GST No. : ' + gst}</p>

            </div>
        </div>
			
		<div id="customer">

            <p id="customer-title">${customerName}</p>
            <p>${customerContact}</p>
            <p>${customerDetails}</p>
            ${customerGST ? (`<p>GST no. ${customerGST}</p>`) : ('')}

            <table id="meta">
                <tr>
                    <td class="meta-head">Date</td>
                    <td><span id="date">${date}</span></td>
                </tr>
            </table>
		</div>
		
		<table id="items">
		
		  <thead>
            <th>Date</th>
            <th>Credit</th>
            <th>Debit</th>
            <th>Running Balance</th>
          </thead>
          
          ${ledger.map((product, i) => {
        let runningBal = prevRunninBal + product.debit - product.credit;
        prevRunninBal = runningBal;
        return `
                <tr class="item-row" key= ${i}>
                    <td class="item-name">${moment(product.date).format("DD/MM/YYYY")}</td>
                    <td>${(product.credit).toFixed(2)}</td>
                    <td>${(product.debit).toFixed(2)}</td>
                    <td>${(runningBal).toFixed(2)} </td>
		        </tr> `;
    })}

        ${ledger.length < 6 ? `<tr class="item-row"><td colspan='4'></td></tr>
        <tr class="item-row"><td colspan='4'></td></tr>`
            : ""}

		  <tr>
		      <td colspan="1" class="blank end"> </td>
		      <td colspan="1" class="total-line">Credit</td>
		      <td colspan="2" class="total-value"><span id="credit">Rs. ${(credit).toFixed(2)}</span></td>
		  </tr>
		  <tr>
		      <td colspan="1" class="blank "> </td>
		      <td colspan="1" class="total-line">Total Debit</td>
		      <td colspan="2" class="total-value"><span id="debit">Rs. ${debit.toFixed(2)}</span></td>
		  </tr>
		  <tr>
		      <td colspan="1" class="blank "> </td>
		      <td colspan="1" class="total-line">Balance</td>
		      <td colspan="2" class="total-value"><span id="total">Rs. ${balance.toFixed(2)}</span></td>
		  </tr>
		
		</table>
		
		<div id="terms">
		  <h5>Terms</h5>
		  <span>All jurisdiction are subjected to district court.</span>
		</div>
	
	</div>
	
</body>

</html>
    
    `;
}

export default ledgerPattern